import { LOGISTICCOMPANY_PREPARE_CHANGE } from "state/auth";
import { FETCH_JOBS, CREATE_JOBS } from "./index";

const initialState = {
  data: {},
  loaded: false,
  error: null
};

export default function auth(state = initialState, action = {}) {
  const { type, payload, error } = action;

  if (error) {
    return {
      ...state,
      error: payload
    };
  }

  switch (type) {
    case FETCH_JOBS:
      return {
        ...state,
        data: payload,
        loaded: true,
        error: null
      };

    case CREATE_JOBS:
      return {
        ...state,
        data: payload,
        loaded: true,
        error: null
      };

    case LOGISTICCOMPANY_PREPARE_CHANGE:
      return initialState;

    default:
      return state;
  }
}
